import { METRICS } from '../metrics/constants';

export const otel = {
  trace_parent_header: 'traceparent',
  ignore_urls: [
    /(https?:\/\/bam\.nr-data\.net\/?).*$/,
    /(https?:\/\/otlp\.nr-data\.net\/?).*$/,
  ],
  resources: {
    'service.name': METRICS.SERVICE_NAME,
    'x-meli-trace-bu': METRICS.PLATFORM_ID,
    'x-meli-trace-site': METRICS.SITE_ID,
    'x-meli-trace-platform': METRICS.DEVICE,

    'fury.application': METRICS.APP_NAME,
    'fury.service': METRICS.SCOPE_NAME,
    d2id: METRICS.D2ID,
    'library-name': METRICS.LIBRARY_NAME,
    'library-version': METRICS.LIBRARY_VERSION,

    get 'location.url'() {
      const { location } = window;

      return `${location.origin}${location.pathname}`;
    },
    get 'location.origin'() {
      const { location } = window;

      return location.origin;
    },
    get 'location.pathname'() {
      const { location } = window;

      return location.pathname;
    },
    get 'browser.dark-mode'() {
      const { matchMedia } = window;

      return matchMedia('(prefers-color-scheme: dark)').matches;
    },
    get 'browser.reduced-motion'() {
      const { matchMedia } = window;

      return (
        matchMedia('(prefers-reduced-motion: reduce)').matches ||
        matchMedia('(prefers-reduced-motion: reduce)').matches
      );
    },
    get 'browser.reduced-contrast'() {
      const { matchMedia } = window;

      return (
        matchMedia(
          '(prefers-contrast: custom), (prefers-contrast: less), (prefers-contrast: more)',
        ).matches || matchMedia('(forced-colors: active)').matches
      );
    },
  },
};
